<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Settings':'settings'}]">
            Products
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-product'].isAllowed"
                    :to="{name: 'add-product'}"
                    class="btn btn-link">Add Product<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid flex-flow-column">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    @completed="stopLoadingPage"
                    :tabs="gridTabs"
                    :filter-set="gridFilterSet"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no products</span>
                        <span slot="description">Click on the button below to add your first product.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-product'].isAllowed"
                                class="btn btn-primary" :to="{name: 'add-product'}">
                                Add Product
                            </router-link>
                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import productFilters from '@/common/query/filter/product-filters';
    import productColumns from './product-columns';
    import FilterSet from '@/components/query/filter-set';

    export default {
        name: 'products',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: productColumns,
                gridTabs: new TabsConfiguration({
                    id: 'product-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {createdTime: 'desc'},
                        },
                    ],
                    version: 1,
                    filtersVersion: productFilters.version,
                }),
                gridFilterSet: new FilterSet({store: this.$store, ...productFilters}),
            };
        },
        methods: {
            async provider(params) {
                const productItems = await this.$api(({products}) => products.getAll(params));
                const idFilter = productItems.items.map(item => item.fields.id);
                const planItems = await this.$api(({plans}) => plans.getAll({filter: `productId:${idFilter.join(',')}`}));

                const copy = {...productItems};

                copy.items = copy.items.map((item) => {
                    const member = {...item};
                    member.fields = {...member.fields};
                    member.fields.plans = [];
                    const productPlans = planItems.items.filter(p => p.fields.productId === member.fields.id);
                    member.fields.plans = member.fields.plans.concat(productPlans || []);
                    return member;
                });
                return copy;
            },
        },
    };
</script>
